export default "__VITE_ASSET__BodZcymc__"